import { fetcher } from '@src/utils/fetcher';
import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';

/**
 * check eu online, will return undefined when fetching data or shouldFetch=false
 * @param shouldFetch if shouldFetch=false ,this hook  won't check eu online and will always return undefined
 * @returns
 */
export function useOnlineEU(shouldFetch: boolean): boolean | undefined {
    const countryListUrl = 'https://common.hkjc.com/wa/eu.aspx';

    const { data: euList } = useSWRImmutable<{
        countryCode?: string[];
    }>(shouldFetch ? countryListUrl : null, fetcher, {
        revalidateOnReconnect: true,
    });

    const currentCountryUrl =
        'https://api.ipdata.co?api-key=ac5f659c94717be9e87ee36deff50b57f29b1f12dff205e7c4fbbfd8';

    const { data: currentCountry } = useSWRImmutable<{
        country_code?: string;
    }>(shouldFetch ? currentCountryUrl : null, fetcher, {
        revalidateOnReconnect: true,
    });

    const _isEU = useMemo(() => {
        let isEU: boolean | undefined = undefined;
        if (euList?.countryCode && currentCountry?.country_code) {
            isEU = euList.countryCode.includes(currentCountry.country_code);
        }
        return isEU;
    }, [currentCountry, euList]);

    return _isEU;
}
